// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__NKTEt","detailsBorder":"styles_detailsBorder__2Ds_2"};